import request from "@utils/request";

export function getHomeData() {
  return request.get("index", {}, { login: false });
}

export function getArticleList(q) {
  return request.get("/article/list/", q, { login: false });
}

export function getShare() {
  return request.get("/share", {}, { login: false });
}

export function getArticleDetails(id) {
  return request.get("/article/details/" + id, {}, { login: false });
}

export function getWechatConfig() {
  return request.get(
    "/wechat/config",
    { url: document.location.href },
    { login: false }
  );
}

export function wechatAuth(code, spread, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, login_type },
    { login: false }
  );
}

export function getLogistics() {
  return request.get("/logistics", {}, { login: false });
}

// 协议详情
export function getViewDetails(id) {
  return request.get("articleSingle/details/" + id, {}, { login: false });
}
// 客服二维码
export function getQRcode() {
  return request.get("/config/getCustomerConifg", {}, { login: false });
}

// 客服二维码
export function getGuide() {
  return request.get("/config/getGuidanceConifg", {}, { login: false });
}

// 客服二维码
export function getXeQRcode() {
  return request.get("/config/getXeCustomerConifg", {}, { login: false });
}

// 客服二维码
export function getGRGuide() {
  return request.get("/config/getGrGuidanceConifg", {}, { login: false });
}

export function getSystemConfig(params) {
  return request.get("/config/getSystemConfig", params);
}

// 获取系统配置信息
export function getLcSystemConfig() {
  return request.get("/api/lcSystemConfig");
}
